import { EmptySearch, SavedSearchesState, Search, SearchExpanded } from '@access-erp/common';

import { Forms } from '@/graphql/contracts/_generated_/contracts';
import { GetSavedSearchesQuery } from '../hooks/SavedSearches/savedSearches.gql';


export const getSavedSearch = () => {
  const searchText = new URL(window.location.href).searchParams.get('search') ?? '';
  const filterKey = new URL(window.location.href).searchParams.get('filterKey') ?? '';
  const filterName = new URL(window.location.href).searchParams.get('filterName') ?? '';

  return {
    savedSearch: searchText,
    savedFilterData: {
      filterKey,
      filterName,
    },
  };
};

export const mapSavedSearchResult = (result: GetSavedSearchesQuery | undefined): SavedSearchesState<Forms>[] =>
  result
    ? [
      EmptySearch,
      ...(result?.config?.savedSearches?.map(({ label, value, ...x }) => ({
        ...x,
        label: label ?? x.title ?? '',
        value: value ?? x.rowKey ?? '',
      })) ?? []),
    ]
    : [EmptySearch];

export const convertForGet = <TFilter>(search: Search<Forms> | undefined): SearchExpanded<TFilter, Forms> =>
  search
    ? {
      ...search,
      filter: search.filter && JSON.parse(search.filter),
    } as SearchExpanded<TFilter, Forms>
    : {};